import { useSelector } from "react-redux";
import { Navigate } from "react-router";

const SuperAdminRoutes = ({ children }) => {
  const { isLogged, dataUser } = useSelector((state) => state.auth);

  const isAdmin = Boolean(dataUser?.admin === 1);

  return isLogged && dataUser && isAdmin ? children : <Navigate to="/" />;
  // return children;
};

export default SuperAdminRoutes;
